module.exports = __webpack_public_path__ + "static/media/sample_lmconsignee.d2df1704.csv";